<div class="account">
  <div class="account__profile">
    <img
      src="/assets/images/account/profile-pic.png"
      alt="Profile"
      class="account__avatar"
    />
    <span class="account__username">#blue-formanite-123</span>
    <span class="account__member-since">Member Since: Jul 1, 2024</span>
  </div>

  <div class="account__social-links">
    <a class="account__social-link">
      <img src="/assets/images/account/steam.svg" alt="Steam" />
    </a>
    <a class="account__social-link">
      <img src="/assets/images/account/EA_Sports.svg" alt="EA-Sports" />
    </a>
    <a class="account__social-link">
      <img src="/assets/images/account/youtube.svg" alt="Youtube" />
    </a>
    <a class="account__social-link">
      <img src="/assets/images/account/twitch.svg" alt="Twitch" />
    </a>
    <a class="account__social-link">
      <img src="/assets/images/account/discord.svg" alt="Discord" />
    </a>
  </div>

  <div class="account__level">
    <span class="account__level-text">Level 4</span>
    <div class="account__level-bar">
      <div class="account__level-progress"></div>
    </div>
  </div>

  <div class="account__menu">
    <button
      *ngFor="let tab of tabs"
      class="account__menu-item"
      [class.account__menu-item--active]="selectedTab === tab.route"
      (click)="onTabClick(tab)"
    >
      <div class="account__menu-item-inner">
        <span nz-icon nzType="ng-zorro:{{ tab.icon }}"></span>
        <span>{{ tab.label }}</span>
      </div>
    </button>
  </div>

  <router-outlet></router-outlet>
</div>
